// extracted by mini-css-extract-plugin
module.exports = {"footerCopy":"Footer_footerCopy__2c_IC"};